import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const REMOVE_ROLE_ASSIGNMENT_RESOURCE = 'removeRoleAssignment';

const removeRoleAssignmentService = ComposedComponent =>
  reduxFetch([
    {
      resource: REMOVE_ROLE_ASSIGNMENT_RESOURCE,
      method: 'delete',
      request: (appId, installationId, featureId, roleId, body, callback, t) => ({
        url: apiRoutes.roleAppAssignments(appId, installationId, featureId, roleId),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'removeRoleAssignmentFailed'),
            onSuccessMessage: t('removeRoleAssignmentSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default removeRoleAssignmentService;
